export default __webpack_public_path__ + "static/media/cloud10.4cafa15b.png";